import { render, staticRenderFns } from "./SvgServicesCategory.vue?vue&type=template&id=52ce6aee&scoped=true"
import script from "./SvgServicesCategory.vue?vue&type=script&lang=js"
export * from "./SvgServicesCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgServicesCategory.vue?vue&type=style&index=0&id=52ce6aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce6aee",
  null
  
)

export default component.exports